import { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import { IState } from 'store';
import { ICardsProps } from 'utils/cards';
import { IConfigApplicationProps } from 'store/modules/config';

import * as S from './styles';

interface CardItemProps {
  item: any;
  index: number;
  hovered: boolean;
  length: number;
  animationSelo?: 'yes' | 'only-icon' | 'only-expanded';
}

export default function CardItem({
  item,
  index,
  hovered,
  length,
  animationSelo,
}: CardItemProps) {
  const { ultraDescontao, seloLivre } = useSelector<
    IState,
    IConfigApplicationProps
  >(state => state.config.config);

  const [itemList, setItemList] = useState<ICardsProps>({} as ICardsProps);
  const [selectedIcon, setSelectedIcon] = useState(false);

  useEffect(() => {
    if (item.name === 'UltraDesconto') {
      const painelItem = {
        url: ultraDescontao?.seloVitrineUrl,
        urlExpanded: ultraDescontao?.seloPdpUrl,
        urlExpandedFull: ultraDescontao?.seloPdpUrl,
        urlExpandedMobile: ultraDescontao?.seloMobileExpandidoUrl,
      } as ICardsProps;

      setItemList({ ...item, ...painelItem });
    } else if (item.name === 'SeloLivre') {
      const painelItem = {
        url: seloLivre?.seloLivreExpandido,
        urlExpanded: seloLivre?.seloLivreUrl,
        urlExpandedFull: seloLivre?.seloLivreUrl,
        urlExpandedMobile: seloLivre?.seloLivreExpandidoMobile,
      } as ICardsProps;

      setItemList({ ...item, ...painelItem });
    } else {
      setItemList(item);
    }
  }, [item, ultraDescontao, seloLivre]);

  return (
    <S.Container
      className={`icon-container ${itemList.name} ${animationSelo}`}
      onMouseEnter={() => setSelectedIcon(true)}
      onMouseLeave={() => setSelectedIcon(false)}
      style={{
        position: animationSelo === 'only-expanded' ? 'relative' : 'absolute',
        top: animationSelo === 'only-expanded' ? 0 : `${index * 1.6}rem`,
        left: '0',
        cursor: 'pointer',
        zIndex: animationSelo === 'only-expanded' ? 1 : length - index + 1,
        transform:
          animationSelo === 'only-expanded'
            ? 'none'
            : hovered
            ? `translateY(${index * 1}rem)`
            : 'translateY(0px)',
        transition: 'transform 0.3s, z-index 0.3s',
      }}
    >
      {animationSelo === 'yes' ? (
        <>
          <div className={`icon${!selectedIcon ? '' : ' show-expanded'}`}>
            <img src={itemList.url} alt={itemList.name} />
          </div>
          <div className={`info${selectedIcon ? ' show-expanded' : ''}`}>
            <img src={itemList.urlExpanded} alt={itemList.name} />
          </div>
        </>
      ) : animationSelo === 'only-icon' ? (
        <div className="icon">
          <img src={itemList.url} alt={itemList.name} />
        </div>
      ) : (
        <div className="info show-expanded">
          <img
            src={
              itemList.urlExpandedFull
                ? itemList.urlExpandedFull
                : itemList.urlExpanded
            }
            alt={itemList.name}
          />
        </div>
      )}
    </S.Container>
  );
}
